import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function ResultsPage() {
  // Set page title and meta tags
  useEffect(() => {
    document.title = '미래인재학원 합격실적 - SKY·의대';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '민락, 옥정, 지행 미래인재학원 입시 결과. SKY, 의대, 약대 등 명문대 합격생 명단과 내신 성적 향상 사례를 소개합니다.');
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '미래인재학원 합격자 현황 - SKY 의대 약대 합격생 명단');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', '민락, 옥정, 지행 미래인재학원 입시 결과. SKY, 의대, 약대 등 명문대 합격생 명단과 내신 성적 향상 사례를 소개합니다.');
    }
  }, []);

  const subjectResults = [
    {
      subject: '수학',
      icon: 'ri-calculator-line',
      grade1: 156,
      grade2: 89,
      grade3: 67,
      total: 312,
    },
    {
      subject: '영어',
      icon: 'ri-english-input',
      grade1: 142,
      grade2: 95,
      grade3: 71,
      total: 308,
    },
    {
      subject: '국어',
      icon: 'ri-book-open-line',
      grade1: 138,
      grade2: 92,
      grade3: 68,
      total: 298,
    },
    {
      subject: '과학',
      icon: 'ri-flask-line',
      grade1: 124,
      grade2: 87,
      grade3: 63,
      total: 274,
    },
  ];

  const universityResults = [
    {
      name: '서울대학교',
      count: 23,
      majors: ['의예과 3명', '공과대학 8명', '경영대학 5명', '자연과학대 7명'],
    },
    {
      name: '연세대학교',
      count: 31,
      majors: ['의예과 4명', '공과대학 12명', '경영대학 8명', '이과대학 7명'],
    },
    {
      name: '고려대학교',
      count: 28,
      majors: ['의과대학 3명', '공과대학 11명', '경영대학 9명', '이과대학 5명'],
    },
    {
      name: '의·치·한·약대',
      count: 45,
      majors: ['의예과 18명', '치의예과 12명', '한의예과 8명', '약학과 7명'],
    },
    {
      name: '성균관대학교',
      count: 34,
      majors: ['반도체시스템공학 6명', '소프트웨어학과 9명', '경영학과 11명', '자연과학 8명'],
    },
    {
      name: '한양대학교',
      count: 29,
      majors: ['공과대학 14명', '경영대학 8명', '자연과학대 7명'],
    },
  ];

  const yearlyProgress = [
    { year: '2022', students: 187, topUniv: 89, grade1: 412 },
    { year: '2023', students: 214, topUniv: 103, grade1: 478 },
    { year: '2024', students: 256, topUniv: 128, grade1: 542 },
    { year: '2025', students: 289, topUniv: 156, grade1: 612 },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation currentPage="results" />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-black via-gray-900 to-black overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-yellow-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-yellow-600 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block px-6 py-2 bg-yellow-400/10 border border-yellow-400/30 rounded-full mb-6">
            <span className="text-yellow-400 font-semibold">2025학년도 입시 결과</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            미래인재학원 <span className="text-yellow-400">합격 실적</span>
          </h1>
          <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
            체계적인 커리큘럼과 최고의 강사진이 만들어낸 놀라운 성과
          </p>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-2xl border border-yellow-400/20">
              <div className="text-5xl font-bold text-yellow-400 mb-2">289명</div>
              <div className="text-gray-300">전체 수강생</div>
            </div>
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-2xl border border-yellow-400/20">
              <div className="text-5xl font-bold text-yellow-400 mb-2">156명</div>
              <div className="text-gray-300">주요대학 합격</div>
            </div>
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-2xl border border-yellow-400/20">
              <div className="text-5xl font-bold text-yellow-400 mb-2">612명</div>
              <div className="text-gray-300">1등급 달성</div>
            </div>
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-2xl border border-yellow-400/20">
              <div className="text-5xl font-bold text-yellow-400 mb-2">45명</div>
              <div className="text-gray-300">의·치·한·약대</div>
            </div>
          </div>
        </div>
      </section>

      {/* Subject Results */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-black mb-4">
              과목별 <span className="text-yellow-500">1등급 달성 현황</span>
            </h2>
            <p className="text-lg text-gray-600">2025학년도 수능 기준</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {subjectResults.map((item, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border-2 border-gray-200 hover:border-yellow-400 transition-all duration-300 hover:shadow-xl"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center mb-6 mx-auto">
                  <i className={`${item.icon} text-3xl text-black`}></i>
                </div>
                <h3 className="text-2xl font-bold text-black text-center mb-6">{item.subject}</h3>
                
                <div className="space-y-4">
                  <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                    <span className="text-gray-600">1등급</span>
                    <span className="text-2xl font-bold text-yellow-500">{item.grade1}명</span>
                  </div>
                  <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                    <span className="text-gray-600">2등급</span>
                    <span className="text-xl font-semibold text-gray-700">{item.grade2}명</span>
                  </div>
                  <div className="flex justify-between items-center pb-3 border-b border-gray-200">
                    <span className="text-gray-600">3등급</span>
                    <span className="text-xl font-semibold text-gray-700">{item.grade3}명</span>
                  </div>
                  <div className="flex justify-between items-center pt-2">
                    <span className="text-gray-800 font-semibold">합계</span>
                    <span className="text-2xl font-bold text-black">{item.total}명</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* University Results */}
      <section className="py-20 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              대학별 <span className="text-yellow-400">합격 현황</span>
            </h2>
            <p className="text-lg text-gray-300">2025학년도 정시/수시 합격자 기준</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {universityResults.map((univ, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-2xl border border-yellow-400/30 hover:border-yellow-400 transition-all duration-300 hover:shadow-2xl"
              >
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-2xl font-bold text-white">{univ.name}</h3>
                  <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center">
                    <span className="text-2xl font-bold text-black">{univ.count}</span>
                  </div>
                </div>

                <div className="space-y-3">
                  {univ.majors.map((major, idx) => (
                    <div
                      key={idx}
                      className="flex items-center space-x-3 text-gray-300"
                    >
                      <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                      <span>{major}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Yearly Progress */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-black mb-4">
              연도별 <span className="text-yellow-500">성적 향상 추이</span>
            </h2>
            <p className="text-lg text-gray-600">지속적으로 성장하는 미래인재학원</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {yearlyProgress.map((year, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border-2 border-gray-200 hover:border-yellow-400 transition-all duration-300"
              >
                <div className="text-center mb-6">
                  <div className="inline-block px-4 py-2 bg-yellow-400 rounded-full mb-4">
                    <span className="text-xl font-bold text-black">{year.year}</span>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="text-center pb-4 border-b border-gray-200">
                    <div className="text-3xl font-bold text-black mb-1">{year.students}명</div>
                    <div className="text-sm text-gray-600">전체 수강생</div>
                  </div>
                  <div className="text-center pb-4 border-b border-gray-200">
                    <div className="text-3xl font-bold text-yellow-500 mb-1">{year.topUniv}명</div>
                    <div className="text-sm text-gray-600">주요대 합격</div>
                  </div>
                  <div className="text-center pt-2">
                    <div className="text-3xl font-bold text-black mb-1">{year.grade1}명</div>
                    <div className="text-sm text-gray-600">1등급 달성</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-r from-yellow-400 to-yellow-600 p-12 rounded-3xl text-center">
            <h3 className="text-3xl font-bold text-black mb-4">
              매년 성장하는 합격률, 그 비결은?
            </h3>
            <p className="text-lg text-gray-900 mb-8 max-w-3xl mx-auto">
              체계적인 학습 시스템과 개인별 맞춤 관리, 그리고 최고의 강사진이 만들어내는 결과입니다.
            </p>
            <Link
              to="/about"
              className="inline-block px-8 py-4 bg-black text-yellow-400 font-bold rounded-full hover:bg-gray-900 transition-colors whitespace-nowrap"
            >
              학원소개 자세히 보기
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
